import { OrderFilterContainer } from '../sharedStyles'
import { DatePicker } from 'ComponentLibrary'
import { ComponentProps } from 'react'

export const OrderDateFilter = ({
    label,
    value,
    inputFieldStyles,
    onChange,
    locale,
}: Pick<ComponentProps<typeof DatePicker>, 'label' | 'value' | 'inputFieldStyles' | 'onChange' | 'locale'>) => {
    return (
        <OrderFilterContainer>
            <DatePicker size="small" label={label} value={value} onChange={onChange} inputFieldStyles={inputFieldStyles} locale={locale} />
        </OrderFilterContainer>
    )
}
